module.exports = "<p>\n  development works!\n</p>\n"